export { default } from './brandLogo'
